<template>
  <v-tabs grow show-arrows
      background-color="primary" dark
      slider-color="secondary" slider-size="5">
    <v-tab v-for="(tab, i) in tabs" :key="i"
      :to="{ name: tab.path, params: { savePosition: true } }"
      @click="$emit('click')" >
      {{tab.label}}
      <v-avatar v-if="tab.badgeInfo"
        class="ml-2" color="secondary" size="25">
        {{tab.badgeInfo}}
      </v-avatar>
    </v-tab>
  </v-tabs>
</template>

<script>
export default {
  name: 'EsTabs',
  props: {
    tabs: {
      type: Array,
      required: false,
      default: () => [],
    },
  }
};
</script>
